// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Form__Label = require("./Form__Label.bs.js");
let InputStyles = require("./InputStyles.bs.js");
let TailwindMerge = require("tailwind-merge");
let Form__HelpLabel = require("./Form__HelpLabel.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let TailwindVariants = require("tailwind-variants");
let ReactAriaComponents = require("react-aria-components");

let textareaStyles = TailwindVariants.tv({
  base: "resize-none",
  variants: {
    isDisabled: {
      true: "bg-zinc-50 text-zinc-500"
    }
  }
});

let Styles = {
  textareaStyles: textareaStyles
};

function Form__TextAreaField(props) {
  let __rows = props.rows;
  let status = props.status;
  let helpText = props.helpText;
  let labelText = props.labelText;
  let rows = __rows !== undefined ? __rows : 5;
  return JsxRuntime.jsxs(ReactAriaComponents.TextField, {
    children: [
      labelText !== undefined ? JsxRuntime.jsx(Form__Label.make, {
          labelText: labelText,
          optionalText: props.optionalText
        }) : null,
      helpText !== undefined ? JsxRuntime.jsx(Form__HelpLabel.make, {
          children: helpText
        }) : null,
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(ReactAriaComponents.TextArea, {
          className: r => TailwindMerge.twMerge([
            InputStyles.baseInputStyles,
            InputStyles.inputStyles({
              isFocused: r.isFocused,
              isInvalid: r.isInvalid,
              isDisabled: r.isDisabled,
              status: status
            }),
            textareaStyles(r)
          ]),
          ref: props.inputRef,
          onChange: props.onChange,
          onKeyDown: props.onKeyDown,
          onBlur: props.onBlur,
          onFocus: props.onFocus,
          disabled: props.disabled,
          rows: rows
        }),
        className: "flex flex-col"
      })
    ],
    className: _r => "flex flex-col",
    id: props.id,
    value: props.value,
    placeholder: props.placeholderText
  });
}

let make = Form__TextAreaField;

exports.Styles = Styles;
exports.make = make;
/* textareaStyles Not a pure module */
